export const JSON_ONE3NW = {

        "ag_id": "Paygate",
        "me_id": "202205240004",
        "order_no": "231211212=",
        "ag_ref": "34687909876"


};
